import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { PERMISSION_LIST } from 'common/constants/permissions';

export default () => {
    const { t } = useTranslation();
    const { pathname } = useLocation();

    const permission = [
        PERMISSION_LIST.ALLIANCE_PRODUCT_APPLICATIONS_PERMISSION,
    ];

    const options = [
        {
            label: t('Quote', { count: 2 }),
            permission: permission,
            selected: ['/quotes'].includes(pathname),
            to: '/quotes',
        },
        {
            label: t('Request', { count: 2 }),
            permission: permission,
            selected: ['/financing'].includes(pathname),
            to: '/financing',
        },
        {
            label: t('Funnel'),
            permission: permission,
            selected: ['/funnel'].includes(pathname),
            to: '/funnel',
        },
    ];

    return options;
};
